import IValidationRule from "./ValidationRule";

export default class ValidationRulePassword implements IValidationRule {
    private _message: string | undefined;

    public get message(): string | undefined {
        return this._message;
    }

    public check(value: any): boolean {
        this._message = undefined;

        if (value == null || (value + "").length === 0) {
            return true;
        }

        if (value.length < 8) {
            this._message = `8자리 이상 입력해 주세요.`;

            return false;
        }

        // const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%\\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/;
        // const regExp = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[`~!@#$%^&*()-_=+[{]}\\|;:\'\",<.>/?]).{8,}$');
        const regExp = /^(|(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~!@#$%^&*()\-_=\+\[{\]}|;:'",<.>]).{8,})$/;

        if (!regExp.test(value)) {
            this._message = `영문, 숫자, 특수문자를 혼합하여 입력해 주세요.`;
            return false;
        }

        return true;
    }
}
